import React, { useState, useRef } from "react"
import styled from "styled-components"
import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import breakpoints from "../../../styles/breakpoints"
import { useI18next } from "gatsby-plugin-react-i18next"

const SignupContainer = styled.div``

const Title = styled.div`
  ${fonts.ivyPrestoLight};
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.trueBlack};
  letter-spacing: 1px;
  margin-bottom: 12px;
  text-transform: lowercase;

  @media (min-width: ${breakpoints.md}) {
    font-size: 12px;
  }
`

const StyledForm = styled.form`
  position: relative;
`

const SubmitButton = styled.button`
  ${fonts.ivyPrestoLight};
  cursor: pointer;
  border: none;
  background: transparent;
  letter-spacing: 1px;
  text-transform: lowercase;
  font-size: 12px;
  display: flex;
  margin-top: 10px;
  margin-left: auto;
  margin-right: 0;
  color: ${colors.trueBlack};

  span {
    margin-left: 3px;
  }

  @media (min-width: ${breakpoints.md}) {
    border-bottom: 0.5px solid ${colors.trueBlack};
    padding-bottom: 4px;
    padding-left: 30px;
    font-size: 12px;

    span {
      display: none;
    }
    &:hover {
      color: ${colors.lightGreen};
      border-bottom-color: ${colors.lightGreen};
    }
  }
`

const Error = styled.div`
  ${fonts.ivyStyleLight};
  font-size: 11px;
  line-height: 1.4;
  color: ${colors.errorRed};
  margin-top: 4px;
`

const Success = styled.div`
  ${fonts.ivyPrestoLight};
  letter-spacing: 1px;
  text-transform: lowercase;
  font-size: 12px;
  margin-top: 10px;
  margin-left: auto;
  margin-right: 0;
  color: ${colors.trueBlack};
  text-align: right;

  @media (min-width: ${breakpoints.md}) {
    padding-bottom: 4px;
    font-size: 12px;
  }
`

const StyledInput = styled.input`
  ${fonts.ivyStyleLight};
  font-size: 16px;
  line-height: 1.4;
  width: 100%;
  border: 0.5px solid ${colors.trueBlack};
  padding: 9px 14px;
  outline: none;
  color: ${colors.trueBlack};
  padding-right: 40px;
  border-radius: 0;
  @media (min-width: ${breakpoints.lg}) {
    font-size: 12px;
  }
`

const DesktopFooterSignup = ({ submit, status }) => {
  const [email, setEmail] = useState("")
  const submitRef = useRef(null)

  const { t } = useI18next()

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      submitRef.current.click()
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    submit(email)
  }

  return (
    <SignupContainer>
      <Title>{t("footer.desktop.signup")}</Title>
      <StyledForm onSubmit={handleSubmit}>
        <StyledInput
          type="email"
          name="email"
          id="footer-email"
          aria-label={t("footer.email")}
          onChange={(event) => setEmail(event.target.value)}
          onKeyDown={handleKeyDown}
          required
        />
        {status === "error" && <Error>{t("footer.error")}</Error>}
        {status === "success" ? (
          <Success>{t("footer.success")}</Success>
        ) : (
          <SubmitButton ref={submitRef} type="submit">
            {t("footer.desktop.signup.submit")} <span>{`>`}</span>
          </SubmitButton>
        )}
      </StyledForm>
    </SignupContainer>
  )
}

export default DesktopFooterSignup
